// fonts for annotations from https://apidocs.pdf.co/kb/General/pdfco-font-list
export const FontListForAnnotations = [
  { label: "Arial", value: "Arial" },
  { label:  "Arial Black", value:  "Arial Black" },
  { label: "Bahnschrift", value: "Bahnschrift" },
  { label: "Calibri", value: "Calibri" },
  { label: "Cambria", value: "Cambria" },
  { label: "Cambria Math", value: "Cambria Math" },
  { label: "Candara", value: "Candara" },
  { label: "Comic Sans MS", value: "Comic Sans MS" },
  { label: "Consolas", value: "Consolas" },
  { label: "Constantia", value: "Constantia" },
  { label: "Corbel", value: "Corbel" },
  { label: "Courier New", value: "Courier New" },
  { label: "Ebrima", value: "Ebrima" },
  { label: "Franklin Gothic Medium", value: "Franklin Gothic Medium" },
  { label: "Gabriola", value: "Gabriola" },
  { label: "Gadugi", value: "Gadugi" },
  { label: "Georgia", value: "Georgia" },
  { label: "HoloLens MDL2 Assets", value: "HoloLens MDL2 Assets" },
  { label: "Impact", value: "Impact" },
  { label: "Ink Free", value: "Ink Free" },
  { label: "Javanese Text", value: "Javanese Text" },
  { label: "Leelawadee UI", value: "Leelawadee UI" },
  { label: "Lucida Console", value: "Lucida Console" },
  { label: "Lucida Sans Unicode", value: "Lucida Sans Unicode" },
  { label: "Malgun Gothic", value: "Malgun Gothic" },
  { label: "Marlett", value: "Marlett" },
  { label: "Microsoft Himalaya", value: "Microsoft Himalaya" },
  { label: "Microsoft JhengHei", value: "Microsoft JhengHei" },
  { label: "Microsoft New Tai Lue", value: "Microsoft New Tai Lue" },
  { label: "Microsoft PhagsPa", value: "Microsoft PhagsPa" },
  { label: "Microsoft Sans Serif", value: "Microsoft Sans Serif" },
  { label: "Microsoft Tai Le", value: "Microsoft Tai Le" },
  { label: "Microsoft YaHei", value: "Microsoft YaHei" },
  { label: "Microsoft Yi Baiti", value: "Microsoft Yi Baiti" },
  { label: "MingLiU-ExtB", value: "MingLiU-ExtB" },
  { label: "Mongolian Baiti", value: "Mongolian Baiti" },
  { label: "MS Gothic", value: "MS Gothic" },
  { label: "MV Boli", value: "MV Boli" },
  { label: "Myanmar Text", value: "Myanmar Text" },
  { label: "Nirmala UI", value: "Nirmala UI" },
  { label: "Palatino Linotype", value: "Palatino Linotype" },
  { label: "Segoe MDL2 Assets", value: "Segoe MDL2 Assets" },
  { label: "Segoe Print", value: "Segoe Print" },
  { label: "Segoe Script", value: "Segoe Script" },
  { label: "Segoe UI", value: "Segoe UI" },
  { label: "Segoe UI Historic", value: "Segoe UI Historic" },
  { label: "Segoe UI Emoji", value: "Segoe UI Emoji" },
  { label: "Segoe UI Symbol", value: "Segoe UI Symbol" },
  { label: "SimSun", value: "SimSun" },
  { label: "Sitka", value: "Sitka" },
  { label: "Sylfaen", value: "Sylfaen" },
  { label: "Symbol", value: "Symbol" },
  { label: "Tahoma", value: "Tahoma" },
  { label: "Times New Roman", value: "Times New Roman" },
  { label: "Trebuchet MS", value: "Trebuchet MS" },
  { label: "Verdana", value: "Verdana" },
  { label: "Webdings", value: "Webdings" },
  { label: "Wingdings", value: "Wingdings" },
  { label: "Yu Gothic", value: "Yu Gothic" },
  { label: "MS Gothic", value: "MS Gothic" },
  { label: "MS Mincho", value: "MS Mincho" },
  { label: "Yu Gothic", value: "Yu Gothic" },
  { label: "SimSun", value: "SimSun" },
  { label: "MingLiU", value: "MingLiU" },
  { label: "Microsoft YaHei", value: "Microsoft YaHei" },
  { label: "Malgun Gothic", value: "Malgun Gothic" },
  { label: "Miriam", value: "Miriam" },
  { label: "Aldhabi", value: "Aldhabi" },
  { label: "Andalus", value: "Andalus" },
  { label: "Arabic Typesetting", value: "Arabic Typesetting" },
];

// built-in 14 pdf fonts only (they are prebuilt into every pdf viewer)
export const FontListForPDFFormFields = [
  { label: "Arial", value: "Arial" },
  { label: "Arial Black", value: "ArialBlack" },
  { label: "Courier", value: "Courier" },
  { label: "Courier Bold", value: "Courier-Bold" },
  { label: "Courier Oblique", value: "Courier-Oblique" },
  { label: "Courier Bold Oblique", value: "Courier-BoldOblique" },
  { label: "Helvetica", value: "Helvetica" },
  { label: "Helvetica Bold", value: "Helvetica-Bold" },
  { label: "Helvetica Oblique", value: "Helvetica-Oblique" },
  { label: "Helvetica Bold Oblique", value: "Helvetica-BoldOblique" },
  { label: "Symbol", value: "Symbol" },
  { label: "Times Roman", value: "Times-Roman" },
  { label: "Times Bold", value: "Times-Bold" },
  { label: "Times Italic", value: "Times-Italic" },
  { label: "Times Bold Italic", value: "Times-BoldItalic" },
];
